export default {
  accountExists: 'An account with this email address already exists. ' +
    'Click <a href="/login">here</a> to sign in.',

  errorCheckingEmail: 'An error occurred checking your email address. ' +
    'We have been notified of the issue.',

  errorCreatingUser: 'An error occurred creating your account. ' +
    'We have been notified of the issue.'
};
